import * as types from "../types/produtos";

const INITIAL_STATE = {
  produto_filtro: {
    titulo: "",
    status: "",
    destaque: "",
    galeria_imagens: "",
  },
  produto_page: 1,
  produto_perpage: 10,
  produto_total: 0,
  produto_lista: [],
  produto: {},
  loading: false,
  produto_complementos: [],

  categoria_lista: [],
  categorias_page: 1,
  categorias_perpage: 10,
  categorias_total: 0,

  complemento_filtro: {
    titulo: "",
  },
  complemento_page: 1,
  complemento_perpage: 10,
  complemento_total: 0,
  complemento_lista: [],
  controlar_estoque: 0,

  imagens_produto: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LOAD_DELIVE_PRODUTO_COMPLEMENTOS:
      return { ...state, produto_complementos: action.payload };
    case types.SET_DELIV_PRODUTO:
      return { ...state, produto: action.payload };
    case types.LOAD_DELIV_PRODUTOS:
      return { ...state, produto_lista: action.payload };
    case types.SET_PAGE_DELIV_PRODUTO:
      return { ...state, produto_page: action.payload };
    case types.SET_PERPAGE_DELIV_PRODUTO:
      return { ...state, produto_perpage: action.payload };
    case types.SET_TOTAL_DELIV_PRODUTO:
      return { ...state, produto_total: action.payload };
    case types.LOADING_DELIV_PRODUTO:
      return { ...state, loading: action.payload };
    case types.SET_FILTRO_DELIV_PRODUTO:
      return {
        ...state,
        produto_filtro: { ...state.produto_filtro, ...action.payload },
      };

    case types.LOAD_DELIV_CATEGORIAS:
      return { ...state, categoria_lista: action.payload };
    case types.SET_PAGE_DELIV_CATEGORIA:
      return { ...state, categorias_page: action.payload };
    case types.SET_PERPAGE_DELIV_CATEGORIA:
      return { ...state, categorias_perpage: action.payload };
    case types.SET_TOTAL_DELIV_CATEGORIA:
      return { ...state, categorias_total: action.payload };

    case types.SET_CONTROLAR_ESTOQUE:
      return { ...state, controlar_estoque: action.payload };
    case types.LOAD_COMPLEMENTOS:
      return { ...state, complemento_lista: action.payload };
    case types.SET_PAGE_COMPLEMENTO:
      return { ...state, complemento_page: action.payload };
    case types.SET_PERPAGE_COMPLEMENTO:
      return { ...state, complemento_perpage: action.payload };
    case types.SET_TOTAL_COMPLEMENTO:
      return { ...state, complemento_total: action.payload };
    case types.LOADING_COMPLEMENTO:
      return { ...state, loading: action.payload };
    case types.SET_FILTRO_COMPLEMENTO:
      return {
        ...state,
        complemento_filtro: { ...state.complemento_filtro, ...action.payload },
      };

    case types.SET_IMAGENS_PRODUTO:
      return { ...state, imagens_produto: action.payload };
    default:
      return state;
  }
};
